import(/* webpackMode: "eager" */ "C:\\Users\\Serhat Altun\\Downloads\\ser\\src\\app\\datenschutz\\page.tsx");
